export default "__VITE_ASSET__CcytkrcO__"